import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-brand-guarantee border-y-4 border-brand-green" data-id="element-148">
      <div className="max-w-4xl mx-auto text-center" data-id="element-149">
        <img src="https://cdn.magicpatterns.com/uploads/iNdd7dNPFTmkMXnAUq87Qt/jo3l6snt.png" alt="Garantía 7 Días de Reembolso" className="w-64 mx-auto mb-8" data-id="element-150" />

        <h2 className="text-4xl md:text-5xl font-black text-brand-dark mb-8 uppercase" data-id="element-151">
          🛡️ GARANTÍA TOTAL — 7 DÍAS SIN PREGUNTAS
        </h2>

        <div className="text-xl md:text-2xl text-gray-800 space-y-4 font-medium mb-8 max-w-3xl mx-auto" data-id="element-152">
          <p data-id="element-153">Si en 7 días no te convence por cualquier motivo:</p>
          <p className="text-3xl md:text-4xl font-black text-brand-green py-6" data-id="element-154">
            ✅ Te devolvemos el 100% de tu dinero.
          </p>
          <p className="font-bold text-brand-dark" data-id="element-155">
            Sin preguntas. Sin vueltas. Así de simple.
          </p>
        </div>
      </div>
    </section>;
}